(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["reflexa-proof-stack"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('.rx-stack').forEach((root) => {
      if (root.dataset.stickyReady) return;
      root.dataset.stickyReady = 'true';
      // UGC karty: velké play přepíná přehrávání, ikona vpravo nahoře zvuk.
      root.addEventListener('click', (udalost) => {
        const play = udalost.target.closest('[data-rx-uv-play]');
        const zvuk = udalost.target.closest('[data-rx-uv-sound]');
        if (!play && !zvuk) return;
        const karta = (play || zvuk).closest('.rx-uv');
        const video = karta && karta.querySelector('[data-rx-uv-video]');
        if (!video) return;
        if (play) {
          if (video.paused) { const slib = video.play(); if (slib && slib.catch) slib.catch(() => {}); }
          else video.pause();
        } else {
          video.muted = !video.muted;
          zvuk.classList.toggle('is-on', !video.muted);
          zvuk.setAttribute('aria-label', video.muted ? 'Ton einschalten' : 'Ton ausschalten');
          if (video.paused) { const slib = video.play(); if (slib && slib.catch) slib.catch(() => {}); }
        }
      });
      root.querySelectorAll('[data-rx-uv-video]').forEach((video) => {
        const karta = video.closest('.rx-uv');
        const play = karta && karta.querySelector('[data-rx-uv-play]');
        if (!play) return;
        const prekresli = () => play.classList.toggle('is-hidden', !video.paused);
        video.addEventListener('play', prekresli);
        video.addEventListener('pause', prekresli);
        prekresli();
      });

      // UGC pás je nekonečný a zvětšuje kartu, která je zrovna uprostřed.
      // Místo klonů se přesouvají samotné uzly, takže videí zůstane pět, ne patnáct.
      // Nekonečný UGC pás. Nepoužívá rolování ani scroll-snap — ty se praly
      // s vyhodnocováním, která karta je uprostřed, a pás se houpal. Pozici
      // řídíme sami přes transform, po každém posunu se pořadí karet otočí
      // bez animace, takže aktivní karta je vždycky prostřední.
      // UGC pás: obyčejné vodorovné rolování s jemným přichytáváním.
      // Žádný transform na pásu (ořez se s ním posouval a uřízl karty vpravo)
      // a žádné přerovnávání karet za běhu (to působilo to poskakování).
      // Zvětšuje se jen měřítkem, takže se rozložení nepřepočítává.
      // UGC pás jede na knihovně Embla (stejnou používá i předloha).
      // Vlastní řešení jsem psal dvakrát a pokaždé se rozbilo na něčem jiném:
      // ořez se posouval s pásem, nebo si přerovnávání konkurovalo s výpočtem
      // středu. Embla řeší nekonečnou smyčku, tažení i přeměřování sama.
      const zapniUgcPas = (skupina) => {
        const pas = skupina.querySelector('.rx-render-group__items');
        if (!pas || pas.dataset.ugcReady) return;
        const karty = [...pas.querySelectorAll('.rx-uv')];
        if (!karty.length) return;
        pas.dataset.ugcReady = 'true';

        // Ořez musí být na obalu, ne na posouvaném pásu.
        let okno = pas.parentNode;
        if (!okno.classList.contains('rx-uv-okno')) {
          okno = document.createElement('div');
          okno.className = 'rx-uv-okno';
          pas.parentNode.insertBefore(okno, pas);
          okno.appendChild(pas);
        }

        const spust = () => {
          if (typeof window.EmblaCarousel !== 'function') return false;
          const embla = window.EmblaCarousel(okno, {
            loop: true,
            align: 'center',
            containScroll: false,
            skipSnaps: false,
            duration: 22,
          });
          // Hraje jen prostřední karta, ostatní se zastaví.
          const oznac = () => {
            const i = embla.selectedScrollSnap();
            embla.slideNodes().forEach((k, index) => {
              const aktivni = index === i;
              k.classList.toggle('is-active', aktivni);
              const video = k.querySelector('video');
              if (!video) return;
              if (aktivni) {
                const slib = video.play();
                if (slib && slib.catch) slib.catch(() => {});
              } else if (!video.paused) {
                video.pause();
              }
            });
          };
          okno.emblaInstance = embla; // přístup pro ladění a testy
          // Pojistka pro případ, že video rozjede prohlížeč sám.
          embla.slideNodes().forEach((k) => {
            const video = k.querySelector('video');
            if (!video) return;
            video.addEventListener('play', () => {
              if (!k.classList.contains('is-active')) video.pause();
            });
          });
          embla.on('select', oznac);
          embla.on('reInit', oznac);
          oznac();
          // klik na krajní kartu ji posune doprostřed
          okno.addEventListener('click', (u) => {
            const karta = u.target.closest('.rx-uv');
            if (!karta || u.target.closest('button')) return;
            const index = embla.slideNodes().indexOf(karta);
            if (index < 0 || index === embla.selectedScrollSnap()) return;
            u.preventDefault();
            embla.scrollTo(index);
          });
          return true;
        };

        if (!spust()) {
          let pokusy = 0;
          const cekej = window.setInterval(() => {
            pokusy += 1;
            if (spust() || pokusy > 60) window.clearInterval(cekej);
          }, 100);
        }
      };

      const stream = root.querySelector('.rx-stream');
      // Rozdělení do sekcí se opíralo výhradně o nadpisy skupin. Když se
      // nadpis v editoru vypne, jeho bloky se přilepily k předchozí skupině —
      // u vodorovného pásu tím zmizely mimo obrazovku. Proto před každou
      // změnu druhu bloku vložíme neviditelnou hranici.
      if (stream && !stream.querySelector('.rx-render-group')) {
        const druhy = [
          ['.rx-uv', 'community'],
          ['.rx-photo-review', 'photo_reviews'],
          ['.rx-video-card', 'rail'],
          ['.rx-explainer', 'wide'],
          ['.rx-spec-panel', 'stats'],
          ['.rx-proof', 'proof'],
          ['.rx-stat', 'stats'],
          ['.rx-family', 'family'],
          ['.rx-family-grid', 'family'],
          ['.rx-review', 'reviews'],
          ['.rx-faq', 'faq'],
        ];
        const druh = (el) => {
          for (const [selektor, styl] of druhy) if (el.matches(selektor)) return styl;
          return null;
        };
        let aktualni = null;
        [...stream.children].forEach((prvek) => {
          if (prvek.matches('[data-rx-group]')) { aktualni = prvek.dataset.rxGroup; return; }
          const styl = druh(prvek);
          if (!styl || styl === aktualni) return;
          const hranice = document.createElement('div');
          hranice.className = 'rx-group__heading rx-group__heading--' + styl + ' rx-group__heading--empty';
          hranice.dataset.rxGroup = styl;
          stream.insertBefore(hranice, prvek);
          aktualni = styl;
        });
      }
      if (stream && !stream.querySelector('.rx-render-group')) {
        [...stream.querySelectorAll('[data-rx-group]')].forEach((heading) => {
          const group = document.createElement('section');
          const items = document.createElement('div');
          group.className = `rx-render-group rx-render-group--${heading.dataset.rxGroup}`;
          items.className = 'rx-render-group__items';
          stream.insertBefore(group, heading);
          group.appendChild(heading);
          group.appendChild(items);
          while (group.nextElementSibling && !group.nextElementSibling.matches('[data-rx-group]')) items.appendChild(group.nextElementSibling);
        });
      }

      root.querySelectorAll('.rx-render-group--community').forEach(zapniUgcPas);

      [...root.querySelectorAll('.rx-render-group--rail')].forEach((group) => {
        const rail = group.querySelector('.rx-render-group__items');
        const cards = [...rail.querySelectorAll('.rx-video-card')];
        if (cards.length < 2 || !cards.some((card) => card.querySelector('video'))) return;
        const createClone = (card) => {
          const clone = card.cloneNode(true);
          clone.dataset.rxClone = 'true';
          clone.setAttribute('aria-hidden', 'true');
          clone.inert = true;
          return clone;
        };
        cards.slice().reverse().forEach((card) => rail.prepend(createClone(card)));
        cards.forEach((card) => rail.appendChild(createClone(card)));
        const dots = document.createElement('div');
        dots.className = 'rx-carousel-dots';
        const buttons = cards.map((card, index) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'rx-carousel-dot';
          button.setAttribute('aria-label', `Video ${index + 1} anzeigen`);
          button.setAttribute('aria-current', index === 0 ? 'true' : 'false');
          button.addEventListener('click', () => {
            const segmentWidth = cards[0].offsetLeft - rail.firstElementChild.offsetLeft;
            const cardOffset = card.offsetLeft - cards[0].offsetLeft;
            rail.scrollTo({ left: segmentWidth + cardOffset, behavior: 'smooth' });
          });
          dots.appendChild(button);
          return button;
        });
        const updateDots = () => {
          const segmentWidth = cards[0].offsetLeft - rail.firstElementChild.offsetLeft;
          const position = ((rail.scrollLeft - segmentWidth) % segmentWidth + segmentWidth) % segmentWidth;
          const nearest = cards.reduce((best, card, index) => {
            const cardOffset = card.offsetLeft - cards[0].offsetLeft;
            const distance = Math.min(Math.abs(cardOffset - position), segmentWidth - Math.abs(cardOffset - position));
            return distance < best.distance ? { index, distance } : best;
          }, { index: 0, distance: Infinity }).index;
          buttons.forEach((button, index) => button.setAttribute('aria-current', index === nearest ? 'true' : 'false'));
        };
        // Pás se dřív rozkmital: oprava pozice běžela uprostřed uživatelova posunu
        // a s plynulým posouváním se skok animoval přes celou šířku. Teď se
        // opravuje až po zastavení, skokem a s dočasně vypnutým přichytáváním.
        let opravuji = false;
        let klidTimer;
        const posunBezAnimace = (kam) => {
          opravuji = true;
          const puvodniChovani = rail.style.scrollBehavior;
          const puvodniSnap = rail.style.scrollSnapType;
          rail.style.scrollBehavior = 'auto';
          rail.style.scrollSnapType = 'none';
          rail.scrollLeft = kam;
          rail.offsetHeight;
          rail.style.scrollSnapType = puvodniSnap;
          rail.style.scrollBehavior = puvodniChovani;
          requestAnimationFrame(() => requestAnimationFrame(() => { opravuji = false; }));
        };
        const srovnejPoKlidu = () => {
          if (opravuji) return;
          const segmentWidth = cards[0].offsetLeft - rail.firstElementChild.offsetLeft;
          if (segmentWidth <= 0) return;
          if (rail.scrollLeft < segmentWidth * 0.5) posunBezAnimace(rail.scrollLeft + segmentWidth);
          else if (rail.scrollLeft >= segmentWidth * 1.5) posunBezAnimace(rail.scrollLeft - segmentWidth);
        };
        const centerRail = () => {
          const segmentWidth = cards[0].offsetLeft - rail.firstElementChild.offsetLeft;
          if (segmentWidth <= 0) return;
          posunBezAnimace(segmentWidth);
          updateDots();
        };
        let frame;
        rail.addEventListener('scroll', () => {
          if (opravuji) return;
          cancelAnimationFrame(frame);
          frame = requestAnimationFrame(updateDots);
          clearTimeout(klidTimer);
          klidTimer = setTimeout(srovnejPoKlidu, 180);
        }, { passive: true });

        // Videa v pásu mají běžet pořád, jako gif.
        const videaVPasu = [...rail.querySelectorAll('video')];
        const rozjed = (video) => { const slib = video.play(); if (slib && slib.catch) slib.catch(() => {}); };
        if ('IntersectionObserver' in window) {
          const hlidac = new IntersectionObserver((zaznamy) => {
            zaznamy.forEach((z) => { if (z.isIntersecting) rozjed(z.target); });
          }, { threshold: 0.1 });
          videaVPasu.forEach((video) => {
            hlidac.observe(video);
            video.addEventListener('pause', () => {
              const r = video.getBoundingClientRect();
              if (r.bottom > 0 && r.top < innerHeight) rozjed(video);
            });
          });
        } else { videaVPasu.forEach(rozjed); }
        group.appendChild(dots);
        requestAnimationFrame(centerRail);
        window.addEventListener('resize', centerRail);
      });
      [...root.querySelectorAll('.rx-render-group--photo_reviews')].forEach((group) => {
        const rail = group.querySelector('.rx-render-group__items');
        const cards = [...rail.querySelectorAll('.rx-photo-review')];
        if (cards.length < 2 || group.querySelector('.rx-photo-review-nav')) return;
        // Sbalený text ukazuje tři řádky, ne jen první větu — u krátkých vět
        // to vypadalo, že v recenzi nic není.
        cards.forEach((card) => {
          const text = card.querySelector('[data-rx-review-text]');
          const toggle = card.querySelector('[data-rx-review-toggle]');
          if (!text || !toggle) return;
          // U line-clamp se scrollHeight rovná oříznuté výšce, takže se přetečení
          // nepozná. Změříme plnou výšku bez ořezu a teprve pak ořez nasadíme.
          // Musí to proběhnout hned, ne v dalším snímku: karty se pro
          // nekonečný pás vzápětí klonují a klon by si odnesl schované tlačítko.
          text.classList.remove('is-clamped');
          const plnaVyska = text.scrollHeight;
          const radek = parseFloat(getComputedStyle(text).lineHeight) || 21;
          text.classList.add('is-clamped');
          if (plnaVyska > radek * 3 + 4) toggle.hidden = false;
        });
        const before = cards.map((card) => {
          const clone = card.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.removeAttribute('id');
          return clone;
        });
        const after = before.map((card) => card.cloneNode(true));
        before.reverse().forEach((card) => rail.insertBefore(card, rail.firstChild));
        after.forEach((card) => rail.appendChild(card));
        const nav = document.createElement('div');
        const previous = document.createElement('button');
        const next = document.createElement('button');
        const dots = document.createElement('div');
        nav.className = 'rx-photo-review-nav';
        dots.className = 'rx-photo-review-dots';
        previous.type = next.type = 'button';
        previous.innerHTML = '<span aria-hidden="true">‹</span>';
        next.innerHTML = '<span aria-hidden="true">›</span>';
        previous.setAttribute('aria-label', 'Vorherige Bewertung');
        next.setAttribute('aria-label', 'Nächste Bewertung');
        const step = () => cards[1].offsetLeft - cards[0].offsetLeft;
        const segmentStart = () => cards[0].offsetLeft - rail.offsetLeft;
        const segmentWidth = () => step() * cards.length;
        const dotButtons = cards.map((card, index) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'rx-photo-review-dot';
          dot.setAttribute('aria-label', `Bewertung ${index + 1} anzeigen`);
          dot.addEventListener('click', () => rail.scrollTo({ left: segmentStart() + step() * index, behavior: 'smooth' }));
          dots.appendChild(dot);
          return dot;
        });
        previous.addEventListener('click', () => rail.scrollBy({ left: -step(), behavior: 'smooth' }));
        next.addEventListener('click', () => rail.scrollBy({ left: step(), behavior: 'smooth' }));
        group.addEventListener('click', (event) => {
          const toggle = event.target.closest('[data-rx-review-toggle]');
          if (!toggle) return;
          const text = toggle.previousElementSibling;
          const expanded = text.classList.toggle('is-expanded');
          text.classList.toggle('is-clamped', !expanded);
          toggle.textContent = expanded ? 'Weniger lesen' : 'Mehr lesen';
          toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        });
        let frame;
        const updateReviewNav = () => {
          const start = segmentStart();
          const width = segmentWidth();
          if (rail.scrollLeft < start - step() / 2) rail.scrollLeft += width;
          if (rail.scrollLeft >= start + width - step() / 2) rail.scrollLeft -= width;
          const rawIndex = Math.round((rail.scrollLeft - start) / step());
          const index = ((rawIndex % cards.length) + cards.length) % cards.length;
          dotButtons.forEach((dot, dotIndex) => dot.setAttribute('aria-current', dotIndex === index ? 'true' : 'false'));
        };
        rail.addEventListener('scroll', () => {
          cancelAnimationFrame(frame);
          frame = requestAnimationFrame(updateReviewNav);
        }, { passive: true });
        nav.append(previous, dots, next);
        group.appendChild(nav);
        requestAnimationFrame(() => {
          rail.scrollLeft = segmentStart();
          updateReviewNav();
        });
      });
      const sticky = root.querySelector('[data-rx-sticky]');
      const form = document.querySelector('form[action*="/cart/add"]');
      const submit = form && form.querySelector('[type="submit"]');
      if (!sticky || !submit) return;
      let queued = false;
      const update = () => {
        queued = false;
        sticky.hidden = submit.getBoundingClientRect().bottom >= 0;
      };
      const requestUpdate = () => {
        if (queued) return;
        queued = true;
        requestAnimationFrame(update);
      };
      sticky.hidden = true;
      update();
      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', requestUpdate, { passive: true });
      sticky.querySelector('[data-rx-buy]').addEventListener('click', () => {
        submit.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(() => submit.focus(), 450);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
